import apiClient from "src/utils/apiClient";
import {
  ConfirmResponse,
  FavoriteResponse,
  PostChartPayload,
  PutConfirmResponsePayload,
  PutVotePayload,
} from "./types";
import { FavoriteItem } from "../store/types";

class ChatService {
  private readonly baseURL = "/v2/chart";

  async postChart(payload: PostChartPayload) {
    return await apiClient.post(`${this.baseURL}/chat`, payload);
  }

  async putVote(payload: PutVotePayload) {
    return await apiClient.post(`${this.baseURL}/vote`, payload);
  }

  async getRecentChats() {
    return await apiClient.get(`${this.baseURL}/recent/chats`);
  }

  async putConfirmResponse(payload: PutConfirmResponsePayload) {
    return await apiClient.post<ConfirmResponse>(
      `${this.baseURL}/confirm-response`,
      payload,
    );
  }

  async addFavorite(messageId: string) {
    return await apiClient.put<FavoriteResponse>(
      `${this.baseURL}/favorites/${messageId}`,
    );
  }

  async removeFavorite(messageId: string) {
    return await apiClient.delete<FavoriteResponse>(
      `${this.baseURL}/favorites/${messageId}`,
    );
  }

  async getAllFavorites() {
    const { data } = await apiClient.get(
      `${this.baseURL}/favorites/current_user`,
    );

    const favoritMessages: FavoriteItem[] = data.favorite_messages.map(
      (item) => ({
        messageId: item.message_id,
        userText: item.user_text,
        favoritedAt: item.favorited_at,
      }),
    );

    return favoritMessages;
  }
}

export default new ChatService();
